import React, { useState } from 'react';
import './TextAreaField.css';

interface TextAreaFieldProps {
    label: string;
    value: string;
    onChange: (value: string) => void;
    onFocus?: () => void;
    placeholder?: string;
    error?: string;
    disabled?: boolean;
    required?: boolean;
    rows?: number;
    maxLength?: number;
    className?: string;
    backgroundColor?: string;
}

const TextAreaField: React.FC<TextAreaFieldProps> = ({
    label,
    value,
    onChange,
    onFocus,
    placeholder,
    error,
    disabled = false,
    required = false,
    rows = 4,
    maxLength,
    className = '',
    backgroundColor = '#ffffff'
}) => {
    const [isFocused, setIsFocused] = useState(false);
    const [isFloating, setIsFloating] = useState(value !== '');

    const handleFocus = () => {
        setIsFocused(true);
        setIsFloating(true);
        onFocus?.();
    };

    const handleBlur = () => {
        setIsFocused(false);
        setIsFloating(value !== '');
    };

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        onChange(e.target.value);
    };

    return (
        <div className={`text-area-field-container ${error ? 'error' : ''} ${disabled ? 'disabled' : ''} ${className}`}>
            <div className="text-area-wrapper">
                <textarea
                    className={`text-area-field ${isFloating ? 'floating' : ''}`}
                    value={value}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    placeholder={isFloating ? placeholder : ''}
                    disabled={disabled}
                    rows={rows}
                    maxLength={maxLength}
                    style={{ backgroundColor }}
                />
                <label
                    className={`text-area-label ${isFloating ? 'floating' : ''} ${isFocused ? 'focused' : ''}`}
                    style={{ backgroundColor }}
                >
                    {label}
                    {required && <span className="required-asterisk">*</span>}
                </label>
            </div>
            
            {error && (
                <div className="error-message">
                    <i className="fas fa-exclamation-circle"></i>
                    {error}
                </div>
            )}
            
            {maxLength && (
                <div className="character-count">
                    {value.length}/{maxLength}
                </div>
            )}
        </div>
    );
};

export default TextAreaField;
